import type { ManifestSchemaItem, ManifestSchemaItems } from "@otto-ec/ottoapi-cli";

export function getChildrenOfArray(item: ManifestSchemaItem): ManifestSchemaItems | undefined {
  if (item.type === "array" && item.children && item.children.items.description) {
    return item.children;
  }

  return undefined;
}
